import { useSelector } from 'react-redux';
import * as dealScreenErrorSelectors from '@makemydeal/dr-dash-store/selectors/dealScreenErrorSelectors';
import { getVppProductErrorKey } from '@makemydeal/dr-dash-store/utils/vppProductErrors';
import type { DraftDealProduct } from '@makemydeal/dr-dash-types';

/**
 * Whether one product carries a validation error, so a row shows only its own dot. A predicate rather
 * than a hook because rows are built inside table `render` callbacks, which cannot call hooks.
 */
export const useHasVppProductError = () => {
    const productErrorKeys = useSelector(dealScreenErrorSelectors.getVppProductErrorKeys);

    return (product?: DraftDealProduct): boolean => {
        const errorKey = getVppProductErrorKey(product);
        return Boolean(errorKey) && productErrorKeys.has(errorKey as string);
    };
};

/** Contract-flow errors only, for the alert specific to contract validation. */
export const useHasGapContractError = () => {
    const gapContractErrorKeys = useSelector(dealScreenErrorSelectors.getGapContractErrorKeys);

    return (product?: DraftDealProduct): boolean => {
        const errorKey = getVppProductErrorKey(product);
        return Boolean(errorKey) && gapContractErrorKeys.has(errorKey as string);
    };
};

/** Contract-API coverage-term errors only, for the same contract-validation alert treatment as GAP. */
export const useHasContractApiErroredVPP = () => {
    const contractApiErrorKeys = useSelector(dealScreenErrorSelectors.getContractApiErroredVppErrorKeys);

    return (product?: DraftDealProduct): boolean => {
        const errorKey = getVppProductErrorKey(product);
        return Boolean(errorKey) && contractApiErrorKeys.has(errorKey as string);
    };
};
